import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, LoadingController, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { MenuStateService } from 'src/app/services/menu-state/menu-state.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-deposit-main',
  templateUrl: './deposit-main.component.html',
  styleUrls: ['./deposit-main.component.scss'],
})
export class DepositMainComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  @Input() public navigateBackPage: any;
  
  public paymentVendors: any = [];
  public labels: DepositMainLabels;
  public loading: any

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public utils: UtilsService,
    public loadingController: LoadingController,
    public menuStateService: MenuStateService,
    private platform: Platform
  ){
    this.labels = new DepositMainModel();
    this.showLoading();
  }

  ngOnInit(): void {
  }
  
  ionViewWillEnter(){
    this.getVendorData();
  }

  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('main').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Loading...',
      duration: 3000
    });
  
    this.loading.present();
  }

  onBack = () => {
    console.log("test?", this.navigateBackPage);
    if(  
        !this.navigateBackPage 
      || this.navigateBackPage == "default" 
      || this.navigateBackPage == "DepositMainComponent") return this.navigator.back();
    if(
        this.navigateBackPage == "navbar"
      || this.navigateBackPage == "navbar-text"
      ) return this.navigator.toLobby();
    if(this.navigateBackPage == "sidemenu") {
      this.navigator.dismissAll();
      return this.menuStateService.openSidemenu("main-menu");
    }
    if(this.navigateBackPage == "promotions") return this.navigator.toPromotions(true);
    if(this.navigateBackPage == "MyTransactionMethodsComponent" || this.navigateBackPage == "AccountBalanceComponent") return this.navigator.navigateTo(this.navigateBackPage)
    return this.navigator.navigateTo(this.navigateBackPage);
  }

  public getVendorData(): any{
    return this.cashierService.getActiveTypesCategories({include_types: false}).subscribe((response: any) => {
      if (response.result) {
        let vendors = response.payload;
        this.paymentVendors = vendors.filter(vendor => {
          if (vendor.code === 'VVAP') {
            return this.platform.is('capacitor') && this.platform.is('ios');
          }
          return true;
        });
        this.loading?.dismiss();
      }
    }, error => {
      this.content.scrollToTop(10)
      this.loading?.dismiss();
      console.error("Vendor Data Error", error);
    });
  }

  public goToPaymentPage(pageName){
    const pageToNavigate = this.cashierContentService.getVendorPage(pageName);
    return this.navigator.navigateTo(pageToNavigate, { multipleModals: true }, {navigateBackPage: "DepositMainComponent", pageCode: pageName}); 
  }

  public getPaymentImage(name: string): string{
    let imageUrl: string;
    imageUrl = `url(${this.utils.getDepositCDNAAsset(name)})`;
    return imageUrl;
  }
}
